import keys from '@debbie/common/dist/cache/keys.js';
import { Site, validatePhone } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { useCosmoV2ProviderSubscriptions } from '@debbie/cortex/dist/cosmoV2/index.js';
import { customersEntity, ensureCustomerLoaded, } from '@debbie/cortex/dist/customers/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { errorNotification } from '../../../utils/errors.js';
import Button from '../../Button.js';
import Checkbox from '../../Checkbox.js';
import { PhoneOutgoing, PlusCircle } from '../../Icons/index.js';
import Input from '../../Input.js';
import Modal from '../../Modal.js';
import PhoneInput from '../../PhoneInput.js';
import Well from '../../Well.js';
import SecondaryEntity from './SecondaryEntity.js';
import UserInfoEntity from './UserInfoEntity.js';
const UserPhone = (props) => {
    const { details } = props.user;
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [addSecondaryPhone, setAddSecondaryPhone] = useState(false);
    const [secondaryPhone, setSecondaryPhone] = useState(null);
    const [secondaryPhoneNote, setSecondaryPhoneNote] = useState('');
    const addSecondaryPhoneMutation = useMutation(async () => {
        await customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
            type: 'addSecondaryPhone',
            details: {
                id: crypto.randomUUID(),
                phone: secondaryPhone,
                note: secondaryPhoneNote,
                enabled: true,
            },
        });
        q.invalidate(keys.write.modify(customersEntity, props.user.customerId));
        await ensureCustomerLoaded(props.user.customerId);
    }, {
        onSuccess: () => {
            setSecondaryPhone(null);
            setSecondaryPhoneNote('');
            setAddSecondaryPhone(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'create', lang.errorEntities.phone);
        },
    });
    const patchPhone = useMutation((phone) => props.patchUser({ phone }), {
        onError: (err) => errorNotification(lang, err, 'update', lang.errorEntities.phone),
    });
    const phoneValidation = details &&
        details.phoneValidations &&
        details.phoneValidations.find((pV) => (pV.phone && pV.phone.number) ==
            (details.phone && details.phone.number) &&
            (pV.phone && pV.phone.locale) ==
                (details.phone && details.phone.locale));
    const loader = useCosmoV2ProviderSubscriptions(props.user.userId);
    const providerSubscriptions = h.hasData(loader) ? loader.data : null;
    const isSubscribedToCosmo = providerSubscriptions && providerSubscriptions.length > 0;
    const tags = []
        .concat(phoneValidation &&
        phoneValidation.originalCarrier &&
        phoneValidation.originalCarrier.name
        ? {
            content: phoneValidation.originalCarrier.name,
        }
        : [])
        .concat(phoneValidation &&
        phoneValidation.originalCarrier &&
        phoneValidation.originalCarrier.networkType
        ? {
            content: lang.phoneValidation[phoneValidation.originalCarrier.networkType] || phoneValidation.originalCarrier.networkType,
        }
        : [])
        .concat(phoneValidation &&
        phoneValidation.roaming &&
        phoneValidation.roaming.status &&
        phoneValidation.roaming.status != 'not_roaming'
        ? {
            content: lang.phoneValidation[phoneValidation.roaming.status] || phoneValidation.roaming.status,
        }
        : [])
        .concat(phoneValidation &&
        phoneValidation.reachable &&
        !['reachable', 'unknown'].includes(phoneValidation.reachable)
        ? {
            content: phoneValidation.reachable,
        }
        : []);
    return (React.createElement(React.Fragment, null,
        React.createElement(UserInfoEntity, { tags: tags, title: lang.debtorInfo.phone, value: details.phone, nextToInfo: isSubscribedToCosmo && site === Site.Caseworker ? (React.createElement("div", { "data-tooltip-id": "tooltip-default", "data-tooltip-content": lang.customers.addSecondaryPhones, onClick: () => setAddSecondaryPhone(!addSecondaryPhone), style: { display: 'inline-block', marginRight: '5px' } },
                React.createElement(PlusCircle, { style: { cursor: 'pointer' } }))) : undefined, renderEditor: (selectedValue) => (React.createElement(PhoneInput, { phone: details.phone, loading: patchPhone.isLoading, onChange: (phone) => {
                    phone = phone && phone.number && phone.locale ? phone : null;
                    selectedValue(phone);
                    patchPhone.mutate(phone);
                }, autofocus: true })), renderValue: (value) => {
                return ((value && value.locale && value.number && (React.createElement(React.Fragment, null,
                    React.createElement("a", { href: `tel:${value && value.number
                            ? `${value && value.locale ? `${value.locale}` : ''}
            ${value && value.number}`
                            : null}`, style: { color: 'inherit' } },
                        React.createElement(PhoneOutgoing, { style: { margin: '.2em .3em -.2em  0px' } }),
                        ' ',
                        value && value.number
                            ? `${value && value.locale ? `+${value.locale} ` : ''}
            ${value && value.number}`
                            : null)))) || React.createElement("span", { style: { opacity: 0.5 } }, lang.debtorInfo.phone));
            }, hist: details.phoneHist && !!details.phoneHist.length
                ? details.phoneHist
                : undefined, onChange: (val) => { }, removable: true }),
        props.user.details.secondaryPhones && (React.createElement("div", null,
            props.user.details.secondaryPhones.map((secondaryPhone) => (React.createElement(SecondaryPhone, { key: secondaryPhone.id, secondaryPhone: secondaryPhone, user: props.user }))),
            React.createElement("br", null))),
        addSecondaryPhone && (React.createElement(React.Fragment, null,
            React.createElement(Well, null,
                React.createElement(Input, { placeholder: lang.customers.note, value: secondaryPhoneNote, onChange: (e) => setSecondaryPhoneNote(e.target.value) }),
                React.createElement(PhoneInput, { placeholder: lang.debtorInfo.phone, phone: secondaryPhone, onChange: (p) => setSecondaryPhone(p), noSaveOnValid: true }),
                React.createElement(Button, { size: "small", loading: addSecondaryPhoneMutation.isLoading, onClick: () => addSecondaryPhoneMutation.mutate(), block: true, disabled: !validatePhone(secondaryPhone) }, lang.customers.addSecondaryPhone)),
            React.createElement("br", null)))));
};
export default UserPhone;
const SecondaryPhone = (props) => {
    const { phone, enabled, id, note } = props.secondaryPhone;
    const lang = useSelector((s) => s.lang);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [_note, setNote] = useState(note);
    const [_phone, setPhone] = useState(phone);
    const [_enabled, setEnabled] = useState(enabled);
    const patchSecondaryPhoneMutation = useMutation(async () => {
        await customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
            type: 'patchSecondaryPhone',
            details: {
                id,
                ...(phone !== _phone ? { phone: _phone } : {}),
                ...(note !== _note ? { note: _note } : {}),
                ...(enabled !== _enabled ? { enabled: _enabled } : {}),
            },
        });
        q.invalidate(keys.write.modify(customersEntity, props.user.customerId));
        await ensureCustomerLoaded(props.user.customerId);
    }, {
        onSuccess: () => {
            setEditModalOpen(false);
        },
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.phone);
        },
    });
    return (React.createElement(SecondaryEmailStyled, null,
        React.createElement(SecondaryEntity, { toggleEditModal: () => setEditModalOpen(!editModalOpen), deleteEventType: "deleteSecondaryPhone", id: id, note: note || null, user: props.user, enabled: enabled, render: React.createElement(React.Fragment, null,
                "+",
                phone.locale,
                " ",
                phone.number) }),
        editModalOpen && (React.createElement(Modal, { maxWidth: "500px", onToggle: () => setEditModalOpen(!editModalOpen) },
            React.createElement(Checkbox, { placeholder: lang.customers.enabled, checked: _enabled, onChange: (e) => setEnabled(e.target.checked) }),
            React.createElement(Input, { placeholder: lang.customers.note, value: _note || '', onChange: (e) => setNote(e.target.value) }),
            React.createElement(PhoneInput, { placeholder: lang.debtorInfo.email, phone: _phone, onChange: (p) => p && setPhone(p), noSaveOnValid: true }),
            React.createElement(Button, { disabled: !((phone.number !== _phone.number ||
                    phone.locale !== _phone.locale ||
                    note !== _note ||
                    enabled !== _enabled) &&
                    validatePhone(_phone)), block: true, onClick: () => patchSecondaryPhoneMutation.mutate(), loading: patchSecondaryPhoneMutation.isLoading }, lang.customers.save)))));
};
const SecondaryEmailStyled = styled.div `
  margin-bottom: 8px;
`;
//# sourceMappingURL=UserPhone.js.map